import React from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../components/Button';
import './MapManagementPage.css';

const APPS = [
  {
    id: 'manual-labeling-import',
    badge: 'Import',
    badgeColor: '#0ea5e9',
    title: 'Manual Labeling Map Import',
    description:
      'Pull a human-annotated Mapbox dataset, sanitize it, review the changes, '
      + 'and publish a new version of the resort database.',
    path: '/map-management/import',
  },
  {
    id: 'ski-area-viewer',
    badge: 'Viewer',
    badgeColor: '#14b8a6',
    title: 'Ski Area Viewer',
    description:
      'Any ski area on a map, drawn from the live resort database (runs, lifts, '
      + 'elevations and contours) or from the Mapbox style.',
    path: '/map-management/viewer',
  },
  {
    id: 'version-history',
    badge: 'History',
    badgeColor: '#8b5cf6',
    title: 'Map Version History',
    description:
      'Every published version of the resort database, what changed in it, '
      + 'who published it, and a download of the .gpkg itself.',
    path: '/map-management/versions',
  },
  {
    id: 'user-feedback',
    badge: 'Feedback',
    badgeColor: '#22c55e',
    title: 'User Feedback',
    description:
      'Map problems reported from the phone — a wrong name, difficulty or lift '
      + 'type, or a missing run — shown next to the map data they are about.',
    path: '/map-management/feedback',
  },
  {
    id: 'resort-live-maps',
    badge: 'Live',
    badgeColor: '#f59e0b',
    title: 'Resort Live Maps',
    description:
      'View live run and lift operational status for ski resorts on an interactive map.',
    path: '/map-management/resort-live-maps',
  },
];

const MapManagementPage = () => {
  const navigate = useNavigate();

  return (
    <div className="map-management-page">
      <div className="map-management-page-header">
        <h2>Map Management</h2>
        <p className="map-management-page-subtitle">
          Tools for maintaining REKKIE&apos;s ski-area map data.
        </p>
      </div>

      <div className="map-management-page-content">
        <div className="map-management-grid">
          {APPS.map(app => (
            <div
              key={app.id}
              className="map-app-card"
              onClick={() => navigate(app.path)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => { if (e.key === 'Enter') navigate(app.path); }}
            >
              <div className="map-app-card-header">
                <span className="map-app-badge" style={{ background: app.badgeColor }}>
                  {app.badge}
                </span>
              </div>
              <div className="map-app-card-body">
                <h4>{app.title}</h4>
                <p className="map-app-description">{app.description}</p>
              </div>
              <div className="map-app-card-footer" onClick={(e) => e.stopPropagation()}>
                <Button variant="primary" size="small" onClick={() => navigate(app.path)}>
                  Open
                </Button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MapManagementPage;
